export default __webpack_public_path__ + "static/media/man-head-icon-2.be254ace.svg";